import React from 'react';
import { StyleSheet, css } from 'aphrodite';

// MATERIAL UI 
// import Hidden from '@material-ui/core/Hidden'

export default class SkewBg extends React.Component{

  render(){
    return(
        <section>
            <div className={css(styles.mainContainer)}>
                <section className={css(styles.skewIntro)}>
                </section>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 0,
        width: '100vw',
        height: 3400,
        overflow: 'hidden',
        transform: 'skewY(12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #4D88FF, #457FDD)',
        '@media (max-width:768px)': {
            height: 5000,
        }
    },
    mirrorContainer: {
        position: 'absolute',
        top: 400,
        right: 0,
        height: 400,
        zIndex: -1
    },
    RightMirror : {
        height: 'inherit',
        filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
    }
});


// WEBPACK FOOTER //
// ./src/Components/Portfolio/NfcAndIot/SkewBg.js